import { render } from "./FridgeSettingsPage.vue?vue&type=template&id=2da1ecd6&scoped=true&ts=true"
import script from "./FridgeSettingsPage.vue?vue&type=script&lang=ts"
export * from "./FridgeSettingsPage.vue?vue&type=script&lang=ts"

import "./FridgeSettingsPage.vue?vue&type=style&index=0&id=2da1ecd6&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da1ecd6"]])

export default __exports__